import { render, staticRenderFns } from "./ServiceDueDate.vue?vue&type=template&id=9e565956&"
import script from "./ServiceDueDate.vue?vue&type=script&lang=js&"
export * from "./ServiceDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports